// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import SectionHeader from 'components/text/SectionHeader';
// APOLLO
import organizationByIdQuery from 'ApolloClient/Queries/organizationById';
import { graphql, compose } from 'react-apollo';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';

class AdminEditTeam extends React.PureComponent {
  render() {
    const organization = this.props.organizationByIdQuery.organizationById;
    return (
      <PageContainer flex="center">
        <SectionHeader>Edit Team for {organization.title}</SectionHeader>
      </PageContainer>
    );
  }
}

let options = props => ({
  variables: {
    orgId: props.match.params.orgId,
  },
});

export default compose(
  graphql(organizationByIdQuery, { options, name: 'organizationByIdQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'organizationByIdQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'organizationByIdQuery' }),
)(AdminEditTeam);



// WEBPACK FOOTER //
// ./src/routes/admin-edit-team/index.js